import { Alert, Box, Collapse, Typography } from "@mui/material";
import { TextField } from "mui-rff";
import { styled } from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";
import { DataGrid as MuiDataGrid } from "@mui/x-data-grid";

export const PageBox = styled((props: any) => <Box {...props} />)(
  ({ theme }) => ({
    marginLeft: theme.spacer_n,
    marginRight: theme.spacer_n,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0,
      marginRight: 0
    }
  })
);

export const PageHeader = styled((props: any) => <Typography {...props} />)(
  ({ theme }) => ({
    fontSize: "2em",
    fontWeight: "bold",
    color: theme.palette.black.main
  })
);

export const FormAlert = styled((props: any) => <Alert {...props} />)(
  ({ theme }) => ({
    padding: "2px",
    marginBottom: theme.spacer_m
  })
);

export const FormButton = styled((props: any) => <LoadingButton {...props} />)(
  ({ theme }) => ({
    border: 0,
    fontWeight: 700,
    fontFamily: "OpenSans,Arial",
    lineHeight: "2.3rem",
    padding: "1.5rem 4rem",
    marginRight: "2.4rem",
    marginBottom: "2.4rem",
    textTransform: "none",
    backgroundColor: theme.palette.fuchsiaAccessible.main,
    color: theme.palette.white.main,
    borderRadius: "27.5px",
    fontSize: "1em",
    "&:disabled": {
      border: `0.1rem solid ${theme.palette.disabled.main}`,
      color: theme.palette.white.main,
      backgroundColor: theme.palette.disabled.main
    },
    "&:hover": {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.fuchsiaAccessible.main
    }
  })
);

export const FormTextField = styled((props: any) => <TextField {...props} />)(
  ({ theme }) => ({
    "input::-ms-reveal,input::-ms-clear": {
      display: "none"
    },
    "& .MuiInputLabel-root": {
      paddingLeft: "17px"
    },
    "& .MuiFilledInput-root": {
      overflow: "hidden",
      borderRadius: "27.5px",
      backgroundColor: theme.palette.white.main,
      marginBottom: "1em",
      "& input.MuiFilledInput-input": {
        padding: "25px 24px  8px",
        backgroundColor: `${theme.palette.white.main} !important`
      },
      "&.Mui-error input.MuiFilledInput-input": {
        color: theme.palette.error.main
      },
      "&:hover": {
        backgroundColor: theme.palette.white.main
      },
      "& .MuiIconButton-root": {
        padding: "23px",
        color: theme.palette.fuchsiaAccessible.main,
        "&:focus": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        },
        "&:hover": {
          backgroundColor: "unset"
        },
        "& .MuiSvgIcon-root": {
          fontSize: "20px"
        }
      }
    },
    "& .MuiFormHelperText-root.Mui-error": {
      padding: "12px",
      fontSize: "1.3rem",
      borderRadius: "8px",
      color: theme.palette.white.main,
      backgroundColor: theme.palette.error.main,
      marginBottom: "1em",
      position: "relative",
      span: {
        display: "block"
      },
      "&:before": {
        content: '""',
        width: 0,
        height: 0,
        position: "absolute",
        borderLeft: "10px solid transparent",
        borderRight: "10px solid transparent",
        borderBottom: `10px solid ${theme.palette.error.main}`,
        top: "-10px",
        marginLeft: "40px"
      }
    }
  })
);

export const DataGrid = styled(MuiDataGrid)(({ theme }) => ({
  border: "1px solid #000",
  "& .MuiDataGrid-root": {
    margin: "12px"
  },
  "& .MuiDataGrid-row:nth-child(even)": {
    backgroundColor: theme.palette.grey[300]
  },
  "& .MuiDataGrid-columnHeaders": {
    fontSize: "1.3rem",
    backgroundColor: theme.palette.blueLight.main
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontSize: "1.5rem",
    fontWeight: "bold"
  },
  "& .MuiDataGrid-footerContainer": {
    fontSize: "1.3rem"
  },
  "& .MuiDataGrid-cell": {
    fontSize: "1.3rem"
  },
  "& .MuiTablePagination-displayedRows": {
    display: "none"
  },
  "&.MuiTablePagination-selectLabel": {
    display: "none"
  }
}));

export const DataCollapse = styled((props: any) => <Collapse {...props} />)(
  ({ theme }) => ({
    width: "100%",
    height: "auto",
    display: "flex",
    margin: "10px"
  })
);
